import { CSSObject, styled, Theme } from '@mui/material';
import MuiDrawer from '@mui/material/Drawer';
import { getSidenavBackgroundColor } from './sidenav-colors';

export const DRAWER_WIDTH = 220; // 16rem = 256px
export const DRAWER_WIDTH_COLLAPSED = 56; // 4rem = 64px

const openedMixin = (theme: Theme): CSSObject => ({
  width: DRAWER_WIDTH,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme: Theme): CSSObject => ({
  width: DRAWER_WIDTH_COLLAPSED,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
});

export const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== 'open',
})<{ open: boolean }>(({ theme, open }) => ({
  width: DRAWER_WIDTH,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  ...(open ? openedMixin(theme) : closedMixin(theme)),
  '& .MuiDrawer-paper': {
    backgroundColor: getSidenavBackgroundColor(theme),
    color: 'white',
    overflowY: 'auto',
    // Overrides global * scrollbar rules (tuned for light surfaces) for the dark drawer.
    scrollbarColor: 'rgba(255, 255, 255, 0.35) rgba(255, 255, 255, 0.08)',
    scrollbarWidth: 'thin',
    '&::-webkit-scrollbar': {
      width: 6,
      height: 6,
    },
    '&::-webkit-scrollbar-track': {
      background: 'rgba(255, 255, 255, 0.08)',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'rgba(255, 255, 255, 0.35)',
      borderRadius: 6,
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: 'rgba(255, 255, 255, 0.5)',
    },
    ...(open ? openedMixin(theme) : closedMixin(theme)),
    '& .visible-collapsed': {
      display: open ? 'none' : 'inline-block',
    },
    '& .hidden-collapsed': {
      display: open ? 'block' : 'none',
    },
  },
}));
